import request from '@/utils/request'

/**
 * @description 获取通用配置
 * @returns
 */
export function getPmsConfig() {
  return request.post('/phalapi/public/?service=Pms.Config.getPmsConfig')
}

/**
 * @description 编辑需求
 * @returns
 */
export function editPmsStory(data) {
  return request.post('/phalapi/public/?service=Pms.Story.editPmsStory', data)
}

/**
 * @description 获取需求列表
 * @returns
 */
export function getPmsStoryList(data) {
  return request.post('/phalapi/public/?service=Pms.Story.getPmsStoryList', data)
}

/**
 * @description 获取需求详情
 * @returns
 */
export function getPmsStoryDetail(data) {
  return request.post('/phalapi/public/?service=Pms.Story.getPmsStoryDetail', data)
}

/**
 * @description 改变需求状态
 * @returns
 */
export function changePmsStoryStatus(data) {
  return request.post('/phalapi/public/?service=Pms.Story.changePmsStoryStatus', data)
}

/**
 * @description 删除需求
 * @returns
 */
export function deletePmsStory(data) {
  return request.post('/phalapi/public/?service=Pms.Story.deletePmsStory', data)
}

/**
 * @description 编辑清单
 * @returns
 */
export function editPmsChecklist(data) {
  return request.post('/phalapi/public/?service=Pms.Checklist.editPmsChecklist', data)
}

/**
 * @description 编辑清单分类
 * @returns
 */
export function editPmsCheckCategory(data) {
  return request.post('/phalapi/public/?service=Pms.Checklist.editPmsCheckCategory', data)
}

/**
 * @description 删除清单分类
 * @returns
 */
export function deletePmsCheckCategory(data) {
  return request.post('/phalapi/public/?service=Pms.Checklist.deletePmsCheckCategory', data)
}
/**
 * @description 删除清单
 * @returns
 */
export function deletePmsChecklist(data) {
  return request.post('/phalapi/public/?service=Pms.Checklist.deletePmsChecklist', data)
}

/**
 * @description 看板列表第一页接口
 * @returns
 */
export function getPmsStoryListGroupByStatus(data) {
  return request.post('/phalapi/public/?service=Pms.Story.getPmsStoryListGroupByStatus', data)
}

/**
 * @description 看板列表分页接口
 * @returns
 */
export function getPmsStoryListByStatus(data) {
  return request.post('/phalapi/public/?service=Pms.Story.getPmsStoryListByStatus', data)
}

/**
 * @description 编辑流程
 * @returns
 */
export function editPmsStoryStatus(data) {
  return request.post('/phalapi/public/?service=Pms.Story.editPmsStoryStatus', data)
}

/**
 * @description 编辑自定义字段
 * @returns
 */
export function editPmsField(data) {
  return request.post('/phalapi/public/?service=Pms.Field.editPmsField', data)
}

/**
 * @description 删除自定义字段
 * @returns
 */
export function deletePmsField(data) {
  return request.post('/phalapi/public/?service=Pms.Field.deletePmsField', data)
}

/**
 * @description 编辑需求内自定义字段接口
 * @returns
 */
export function editPmsStoryFieldRelation(data) {
  return request.post('/phalapi/public/?service=Pms.Story.editPmsStoryFieldRelation', data)
}

/**
 * @description 自定义字段排序
 * @returns
 */
export function sortPmsField(data) {
  return request.post('/phalapi/public/?service=Pms.Field.sortPmsField', data)
}

/**
 * @description 审核需求
 * @returns
 */
export function reviewPmsStory(data) {
  return request.post('/phalapi/public/?service=Pms.Story.ReviewPmsStory', data)
}

/**
 * @description 获取需求分组列表
 * @returns
 */
export function getStoryGroupList(data) {
  return request.post('/phalapi/public/?service=Pms.StoryGroup.GetStoryGroupList', data)
}

/**
 * @description 编辑需求分组
 * @returns
 */
export function editStoryGroup(data) {
  return request.post('/phalapi/public/?service=Pms.StoryGroup.EditStoryGroup', data)
}

/**
 * @description 删除需求分组
 * @returns
 */
export function deleteStoryGroup(data) {
  return request.post('/phalapi/public/?service=Pms.StoryGroup.DeleteStoryGroup', data)
}

/**
 * @description 获取分组下的需求列表
 * @returns
 */
export function getGroupStoryList(data) {
  return request.post('/phalapi/public/?service=Pms.Story.getGroupStoryList', data)
}

/**
 * @description 获取想法池列表
 * @returns
 */
export function getIdeaListByGroupid(data) {
  return request.post('/phalapi/public/?service=Pms.Idea.GetIdeaListByGroupid', data)
}

/**
 * @description 获取想法池可筛选数据列表
 * @returns
 */
export function getIdeaGroupidList(data) {
  return request.post('/phalapi/public/?service=Pms.Idea.GetIdeaGroupidList', data)
}

/**
 * @description 编辑需求操作记录备注
 * @returns
 */
export function editStoryLogComment(data) {
  return request.post('/phalapi/public/?service=Pms.Story.editStoryLogComment', data)
}

/**
 * @description 获取需求甘特图列表
 * @param {*} data
 * @returns
 */
export function getPmsGanttList(data) {
  return request.post('/phalapi/public/?service=Pms.StoryTask.GetGanttList', data)
}
/**
 * @description 更新已用工时
 * @param {*} data
 * @returns
 */
export function updateActualCycle(data) {
  return request.post('/phalapi/public/?service=Pms.StoryTask.EditStoryTask', data)
}
/**
 * @description 获取节假日数据(包含周六日)
 * @param {*} data
 * @returns
 */
export function getHolidayList(data) {
  return request.post('/phalapi/public/?service=Pms.StoryTask.GetNonWorkDayList', data)
}
/**
 * @description 提交审核
 * @param {*} data
 * @returns
 */
export function submitPreview(data) {
  return request.post('/phalapi/public/?service=Pms.Story.SubmitReview', data)
}

// 想法池审核
/**
 * @description 提交审核
 * @param {*} data
 * @returns
 */
export function reviewIdea(data) {
  return request.post('/phalapi/public/?service=Pms.Idea.reviewIdea', data)
}

/**
 * @description 编辑需求分类
 * @returns
 */
export function editStoryStatus(data) {
  return request.post('/phalapi/public/?service=Pms.StoryCategory.EditStoryCategory', data)
}
/**
 * @description 删除需求分类
 * @returns
 */
export function deleteStoryCategory(data) {
  return request.post('/phalapi/public/?service=Pms.StoryCategory.deleteStoryCategory', data)
}
/**
 * @description 编辑关键结果
 * @returns
 */
export function editStoryKeyResult(data) {
  return request.post('/phalapi/public/?service=Pms.StoryKeyResult.EditStoryKeyResult', data)
}

/**
 * @description 获取默认关键结果列表
 * @returns
 */
export function getDefaultStoryKeyResultList(data) {
  return request.post('/phalapi/public/?service=Pms.StoryKeyResult.GetDefaultStoryKeyResultList', data)
}

/**
 * @description 获取视图列表
 * @returns
 */
export function getFilterViewsList(data) {
  return request.post('/phalapi/public/?service=Pms.FilterViews.GetList', data)
}
/**
 * @description 新增/编辑视图
 * @returns
 */
export function saveFilterViews(data) {
  return request.post('/phalapi/public/?service=Pms.FilterViews.Save', data)
}
/**
 * @description 删除视图
 * @returns
 */
export function deleteFilterViews(data) {
  return request.post('/phalapi/public/?service=Pms.FilterViews.Delete', data)
}
/**
 * @description 获取问题和成绩列表
 * @returns
 */
export function getStorySummarizeList(data) {
  return request.post('/phalapi/public/?service=Pms.StorySummarize.getList', data)
}
/**
 * @description 设置跟进状态接口
 * @returns
 */
export function updateFieldStatus(data) {
  return request.post('/phalapi/public/?service=Pms.StorySummarize.updateFieldStatus', data)
}
/**
 * @description 获取汇总清单类型
 * @returns
 */
export function GetSummarizeTypeList(data) {
  return request.post('/phalapi/public/?service=Pms.StorySummarize.GetSummarizeTypeList', data)
}
/**
 * @description 新增/修改汇总清单类型
 * @returns
 */
export function EditSummarizeType(data) {
  return request.post('/phalapi/public/?service=Pms.StorySummarize.EditSummarizeType', data)
}
/**
 * @description 删除汇总清单类型
 * @returns
 */
export function DeleteSummarizeType(data) {
  return request.post('/phalapi/public/?service=Pms.StorySummarize.DeleteSummarizeType', data)
}
/**
 * @description 新增/修改汇总清单列表
 * @returns
 */
export function EditSummarizeList(data) {
  return request.post('/phalapi/public/?service=Pms.StorySummarize.EditSummarizeList', data)
}
/**
 * @description 删除汇总清单列表
 * @returns
 */
export function DeleteSummarizeList(data) {
  return request.post('/phalapi/public/?service=Pms.StorySummarize.DeleteSummarizeList', data)
}
/**
 * @description 发送通知
 * @returns
 */
export function SendMessage(data) {
  return request.post('/phalapi/public/?service=Pms.StoryStatus.SendMessage', data)
}
/**
 * @description 通知已读
 * @returns
 */
export function MarkAsRead(data) {
  return request.post('/phalapi/public/?service=Pms.StoryStatus.MarkAsRead', data)
}
/**
 * @description 拖曳排序
 * @returns
 */
export function UpdateStorySort(data) {
  return request.post('/phalapi/public/?service=Pms.Story.UpdateStorySort', data)
}
/**
 * @description 获取需求分类信息
 * @returns
 */
export function getStoryCategoryInfo(data) {
  return request.post('/phalapi/public/?service=Pms.StoryCategory.getStoryCategoryInfo', data)
}
/**
 * @description 批量编辑需求分类
 * @returns
 */
export function BatchEditStoryCategory(data) {
  return request.post('/phalapi/public/?service=Pms.StoryCategory.BatchEditStoryCategory', data)
}

//需求标签列表
export function getStoryTagList(data) {
  return request.post('/phalapi/public/?service=Pms.StoryTag.GetStoryTagList', data)
}
//编辑需求标签
export function editStoryTag(data) {
  return request.post('/phalapi/public/?service=Pms.StoryTag.EditStoryTag', data)
}
//删除需求标签
export function deleteStoryTag(data) {
  return request.post('/phalapi/public/?service=Pms.StoryTag.DeleteStoryTag', data)
}
//删除需求标签
export function getIntegratedViewsData(data) {
  return request.post('/phalapi/public/?service=Pms.IntegratedViews.getIntegratedViewsData', data)
}
//收藏接口
export function toggleCollect(data) {
  return request.post('/phalapi/public/?service=Pms.StoryCollect.ToggleCollect', data)
}
/**
 * @description 获取通用配置
 * @returns
 */
export function updatePmsConfig(data) {
  return request.post('/phalapi/public/?service=Pms.Config.UpdateConfig', data)
}
